/**
 *
 * @Description:
 *
 * Info Icon Tooltip Component contains of info 'i' icon and tooltip
 *
 */

'use strict'

import React, {Component} from 'react'

import PropTypes from 'prop-types'
import {Tooltip} from '../Tooltip'

import './InfoIconTooltip.less'
export default class InfoIconTooltip extends Component {

  static propTypes = {
    placement: PropTypes.oneOf([Tooltip.TooltipPlacement.LEFT, Tooltip.TooltipPlacement.LEFT_BOTTOM, Tooltip.TooltipPlacement.LEFT_TOP, Tooltip.TooltipPlacement.RIGHT, Tooltip.TooltipPlacement.RIGHT_TOP, Tooltip.TooltipPlacement.RIGHT_BOTTOM, Tooltip.TooltipPlacement.TOP, Tooltip.TooltipPlacement.TOP_RIGHT, Tooltip.TooltipPlacement.TOP_LEFT, Tooltip.TooltipPlacement.BOTTOM, Tooltip.TooltipPlacement.BOTTOM_LEFT, Tooltip.TooltipPlacement.BOTTOM_RIGHT]),
    trigger: PropTypes.arrayOf(PropTypes.oneOf([Tooltip.TooltipTrigger.HOVER, Tooltip.TooltipTrigger.CLICK, Tooltip.TooltipTrigger.FOCUS]))
  }

  render () {
    return (
      <Tooltip {...this.props}>
        <span className='nmc-info-icon'>s</span>
      </Tooltip>
    )
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/InfoIconTooltip/index.js